import React, { useState } from "react";
import ItemNumberFinder from "./Main";
import ItemNameFinder from "../item_name_finder/Main";

const item_id = 738424
const vendor_id = 74
  
const Demo = () => {
  const [value1, setValue1] = useState(null)
  const [value2, setValue2] = useState(null)

  return (
    <>
      <div className="d-flex">
        <ItemNumberFinder
          vendor_id={vendor_id}
          value={value1}
          default_value={value2?.id || item_id}
          onChange={(val) => {
            setValue1(val)
            if(val == null) {
              setValue2(val)
            }
          }}
        />
        <ItemNameFinder
          vendor_id={vendor_id}
          value={value2}
          default_value={value1?.id}
          onChange={(val) => {
            setValue2(val)
            if(val == null) {
              setValue1(val)
            }
          }}
        />
      </div>
      
      <br/>
      {value1 && <ul>
        <li>ID: {value1.id}</li>
        <li>Item Number: {value1.item_number}</li>
        <li>Name: {value1.item_name}</li>
      </ul>}
      {value2 && <ul>
        <li>ID: {value2.id}</li>
        <li>Item Number: {value2.item_number}</li>
        <li>Name: {value2.item_name}</li>
      </ul>}
    </>
  )
}

export default Demo;
